import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { I18nextProvider, initReactI18next } from "react-i18next";
import i18next from "i18next";

import common_ar from "./translations/ar/common.json";
import common_en from "./translations/en/common.json";
import IndexContent from "./IndexContent";

i18next.use(initReactI18next).init({
    interpolation: { escapeValue: false },
    lng: localStorage.getItem("lang") || "ar",
    resources: {
        ar: { translation: common_ar },
        en: { translation: common_en },
    },
    fallbackLng: "ar",
});

const root = createRoot(document.getElementById("root"));
root.render(
    <RecoilRoot>
        <BrowserRouter>
            <I18nextProvider i18n={i18next}>
                <IndexContent />
            </I18nextProvider>
        </BrowserRouter>
    </RecoilRoot>
);
